export const ACCOUNTS_PAYABLE_MENU = 'Accounts Payable';
/**
 * Sidebar parent from BE. Plural "Accounts Payable" may still appear in
 * pagePermissions for route access, but is not shown as a sidebar group.
 */
export const ACCOUNT_PAYABLE_MENU = 'Account Payable';
export const EXPENSE_MANAGEMENT_MENU = 'Expense Management';
// Deliberately misspelled: this must match the menu name the backend sends in
// `companyPermissions.pagePermissions[].menu` byte for byte. Verified against devapi
// 2026-09-04, where the payload contains 'Repair & maintainance'. Correcting the spelling here
// would silently break R&M page permissions — the fix has to land in the backend's seed data
// first, and this constant follows it.
export const REPAIR_MAINTENANCE_MENU = 'Repair & maintainance';
export const HOMEPAGE_MENU = 'Homepage';
export const MEAL_DYNAMICS_AI_MENU = 'Meal Dynamics AI';
export const VENDORS_MENU = 'Vendors';

export interface CompanyPageSubMenu {
  page: string;
  pageUrl: string;
}

export interface CompanyPagePermission {
  menu: string;
  subMenus?: CompanyPageSubMenu[];
}

export interface ApNavGroup {
  menu: string;
  subMenus: CompanyPageSubMenu[];
}

/** Same shape as ApNavGroup — BE pagePermissions sidebar groups. */
export type PageNavGroup = ApNavGroup;

/** Same shape as ApNavGroup — Expense sidebar driven by pagePermissions. */
export type ExpenseNavGroup = ApNavGroup;

/** Same shape as ApNavGroup — Repair sidebar driven by pagePermissions. */
export type RmNavGroup = ApNavGroup;

/** Same shape as ApNavGroup — Vendors sidebar driven by pagePermissions. */
export type VendorNavGroup = ApNavGroup;

export interface CompanyActionPermission {
  module: string;
  action: string;
  isAllowed: boolean;
}

export interface CompanyPermission {
  companyId: string;
  pagePermissions?: CompanyPagePermission[];
  actionPermissions?: CompanyActionPermission[];
}
